export default __webpack_public_path__ + "img/3c053ee44a6e92f9799ca565b8050916.svg";